export default {
  computed: {
    labelsRules () {
      return this.getLabels(this.$store.getters.getLanguage).rules
    },
  },
  methods: {
    regex (re) {
      const reg = new RegExp(re)
      return v => reg.test(v) || this.labelsRules.regex
    },
    required () {
      return (v) => !!v || this.labelsRules.req
    },
    maximum (maxNum) {
      return v => (v.length < maxNum) || this.labelsRules.maximum + maxNum + this.labelsRules.character
    },
    minimum (minNum) {
      return v => (!!v && v.length >= minNum) || this.labelsRules.minimum + minNum + this.labelsRules.character
    },
    minimumNum (min) {
      return v => v >= min || this.labelsRules.minimumNum + min
    },
    optionalMinimumNum (min) {
      return v => {
        if (v?.length) {
          return v >= min || this.labelsRules.minimumNum + min
        }
        return true
      }
    },
    optionalMaximumNum (max) {
      return v => {
        if (v?.length) {
          return v <= max || this.labelsRules.maximumNum + max
        }
        return true
      }
    },
    maximumNum (max) {
      return v => v <= max || this.labelsRules.maximumNum + max
    },
    equal (value) {
      return v => (!!v && v === value) || this.labelsRules.equal
    },
    number () {
      return v => v === undefined || v === '' || !isNaN(parseFloat(v)) || this.labelsRules.notValid
    },
  },
}
